import {gql} from '@apollo/client';

export const CREATE_PICKUP_TASK = gql`
  mutation CreatePickupTask($input: PickupTaskInput!) {
    createPickupTask(input: $input) {
      id
      taskDate
      warehouseId
      accountId
      vehicleId
      vehicleModelId
      vehicleTypeId
      startPointType
      startPointValue
      endPointType
      endPointValue
      notes
      status
    }
  }
`; 